module.exports = __webpack_public_path__ + "img/heart.aee5f853.svg";